// Drapeaux de langue : emoji regional-indicator depuis le code pays ISO 3166-1
// alpha-2 et URL d'image (flagUrl en base, sinon flagcdn depuis `flag`).

export const FLAG_CDN = 'https://flagcdn.com';

export function flagEmoji(cc) {
  const s = String(cc || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(s)
    ? String.fromCodePoint(...[...s].map((c) => 0x1F1E6 + c.charCodeAt(0) - 65))
    : '';
}

export function langFlagUrl(lang) {
  if (!lang) return '';
  return lang.flagUrl || (lang.flag ? `${FLAG_CDN}/${String(lang.flag).toLowerCase()}.svg` : '');
}
